import { render } from "./AddCustomerEmployeePage.vue?vue&type=template&id=03a2ce22&scoped=true"
import script from "./AddCustomerEmployeePage.vue?vue&type=script&lang=js"
export * from "./AddCustomerEmployeePage.vue?vue&type=script&lang=js"

import "./AddCustomerEmployeePage.vue?vue&type=style&index=0&id=03a2ce22&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a2ce22"]])

export default __exports__